import * as React from 'react';
import { isEmpty } from 'lodash';
import useHabitat from '../../../hooks/useHabitat';
import './styles.scss';
import SvgImage from '../SvgImage';
import Contact from '../Contact';
import RichText from '../RichText';
import UnderlineTitle from '../UnderlineTitle';
import { Link, Contacts } from '../../../typings';

interface ContentProps {
  title?: string;
  intro?: string;
  contact?: Contacts;
  content?: string;
  link?: Link;
  secondaryLink?: Link;
  downloads?: Link[];
  containerTheme?: string;
  isTitleFloating?: boolean;
  disableUppercase?: boolean;
}

const Content = ({
  title,
  intro,
  contact,
  content,
  link,
  secondaryLink,
  downloads,
  containerTheme = 'white',
  isTitleFloating,
  disableUppercase,
}: ContentProps) => {
  useHabitat();

  return (
    <div className={`content content--${containerTheme} ${isTitleFloating ? 'content--floating' : ''}`}>
      {Boolean(title || contact) && (
        <div className="content__header">
          {title && (
            <UnderlineTitle
              title={title}
              containerTheme={containerTheme}
              disableUppercase={disableUppercase}
            />
          )}

          {(contact && !isEmpty(contact)) && (
            <Contact contact={contact} containerTheme={containerTheme} />
          )}
        </div>
      )}

      {!title && (
        <>
          {intro && (!contact || isEmpty(contact)) && (!title
            ? <h3 className="content__intro">{intro}</h3>
            : <h2 className="content__intro">{intro}</h2>)}
        </>
      )}
      <div className="content__body">
        {title && (
          <>
            {intro && (contact || !isEmpty(contact)) && (title
              ? <h3 className="content__intro">{intro}</h3>
              : <h2 className="content__intro">{intro}</h2>)}
          </>
        )}

        {content && (
          <RichText content={content} containerTheme={containerTheme} />
        )}

        {downloads && (
          <ul className="content__download">
            {downloads.map((download) => (
              <li key={download.url} className="content__download-item">
                <a
                  className={`content__download-link ${download.disableUppercase ? 'disable-uppercase' : ''}`}
                  href={download.url}
                  target="_blank"
                  rel="noopenner noreferrer"
                  aria-label={`Download file: ${download.title}`}
                >
                  {download.title}
                  <SvgImage reference="#icon-download" ariaHidden />
                </a>
              </li>
            ))}
          </ul>
        )}

        {link && (
          /* eslint-disable-next-line react/jsx-no-target-blank */
          <a
            className="content__link"
            href={link.url}
            target={link.isExternal ? '_blank' : '_self'}
            rel={link.isExternal ? 'noopener noreferrer' : ''}
          >
            {link.title}
            <SvgImage title={link.isExternal ? 'External link' : ''} reference="#icon-long-arrow" />
          </a>
        )}
        {secondaryLink && (
          /* eslint-disable-next-line react/jsx-no-target-blank */
          <a
            className="content__link"
            href={secondaryLink.url}
            target={secondaryLink.isExternal ? '_blank' : '_self'}
            rel={secondaryLink.isExternal ? 'noopener noreferrer' : ''}
          >
            {secondaryLink.title}
            <SvgImage title={secondaryLink.isExternal ? 'External link' : ''} reference="#icon-long-arrow" />
          </a>
        )}
      </div>
    </div>
  );
};

export default Content;
